export class HeartRate {
    private constructor(public bpm: number) {}

    public static fromBpm(bpm: number): HeartRate {
        return new HeartRate(bpm);
    }

    static average(...heartRates: HeartRate[]): HeartRate {
        if (heartRates.length === 0) {
            return HeartRate.fromBpm(0);
        }
        const totalBpm = heartRates.reduce((total, heartRate) => total + heartRate.bpm, 0);
        return HeartRate.fromBpm(totalBpm / heartRates.length);
    }
}
